import { doc, DocumentReference, serverTimestamp, updateDoc } from 'firebase/firestore'
import leaveRequestServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { LeaveRequestRaw } from '../../database/tables'
import { ApprovalStatus } from '../../database/enums/ApprovalStatus.enum'

export type SetApprovalLeaveRequestByIdParams = {
  id: string
  approvalStatus: ApprovalStatus
  approvalBy: string | null
}

export default async function setApprovalLeaveRequestById(params: SetApprovalLeaveRequestByIdParams): Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(db, leaveRequestServiceConfigs.collectionName, params.id) as DocumentReference<LeaveRequestRaw>

      await updateDoc(docRef, {
        approvalStatus: params.approvalStatus,
        approvalBy: params.approvalBy,
        approvalUpdatedAt: serverTimestamp(),
      })

      return resolve()
    } catch (e) {
      return reject(e)
    }
  })
}
